import React from 'react';
import {ProtectedRoute} from '../../_common/components/Permissions';
import Contacts from '../pages';
import {pathnames as P} from '../../_common/constants/pathnames';
import {subjects as S} from '../../_common/constants/permissionSubjects';

export const contactsRoute = (
  <ProtectedRoute
    subject={S.CONTACTS_PAGE}
    path={P.CONTACTS_PAGE}
    component={Contacts}
  />
);
